import React from 'react';
import clsx from 'clsx';
import styles from './InfoGrid.module.css';

interface InfoGridProps {
  children: React.ReactNode;
  className?: string;
}

export const InfoGrid: React.FC<InfoGridProps> = ({ children, className }) => {
  return (
    <div className={clsx(styles.infoGrid, className)} data-test-id="info-grid">
      {children}
    </div>
  );
};

interface InfoItemProps {
  label: string;
  children: React.ReactNode;
  className?: string;
}

export const InfoItem: React.FC<InfoItemProps> = ({ label, children, className }) => {
  return (
    <div className={clsx(styles.infoItem, className)}>
      <label>{label}</label>
      <div>{children}</div>
    </div>
  );
};
